import { MouseEventHandler, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useAsDetailQuery } from "src/api/asAPI";
import styled from "styled-components";
import Thumbnail from "../common/Thumbnail";
import ThumbE from "src/assets/images/thumbFnf.svg";
import ThumbS from "src/assets/images/thumbShop.svg";
import ThumbM from "src/assets/images/thumbCompany.svg";
import moment from "moment";
import { useAppSelector } from "src/store/actions/action";
import { useDispatch } from "react-redux";
import { setOnFocusReduce, setWriteNameReduce } from "src/store/reducers/asDetailReduce";
import { userInfo } from "os";
import VideoBox from "../common/VideoBox";
import { SOS_AS_COMMENT, sosContentSet } from "../../utils/sosFunc";
import { useDeleteCommentMutation } from "../../api/noticeAPI";

const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
interface ICmtItemProps {
  onClick?: MouseEventHandler<HTMLLIElement>;
}

const CommentItem = (props: ICmtItemProps) => {
  const dispatch = useDispatch();

  const pathname = location.pathname;
  const pathnameSplit = pathname.split("/");
  const index: any = pathnameSplit[2];
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);

  const [render, setRender] = useState(false);

  const cmtListRef = useRef<HTMLLIElement>(null);

  const [onFocus, setOnFocus] = useState<boolean>(true);

  const asDetail = useAsDetailQuery(index);

  const Thumb: any = {
    E: ThumbE,
    S: ThumbS,
    M: ThumbM,
  };

  useEffect(() => {
    if (render) {
      cmtListRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    setRender(true);
  }, [asDetail.isSuccess && asDetail.data.comments.length]);

  const reCommentBtn = (writeName: string, asCommentIdx: string) => {
    setOnFocus(!onFocus);
    dispatch(setOnFocusReduce(onFocus));
    if (onFocus) {
      dispatch(setWriteNameReduce([writeName, asCommentIdx]));
    } else {
      dispatch(setWriteNameReduce(["", ""]));
    }
  };

  /////////SOS
  const [ugcList, setUgcList] = useState<any>();

  useEffect(() => {
    if (window.localStorage.getItem(SOS_AS_COMMENT)) {
      setUgcList(JSON.parse(window.localStorage.getItem(SOS_AS_COMMENT)!));
    }
  }, []);

  const [deleteComment] = useDeleteCommentMutation();

  const handleDelete = (id: string) => {
    if (confirm("작성하신 댓글을 삭제하시겠어요?")) {
      deleteComment(id).then((e) => {
        // @ts-ignore
        const error = e?.error?.data?.message;
        if (error) {
          return alert(error);
        } else {
          window.location.reload();
        }
      });
    }
  };

  const canDelete = (data: CommentData) => {
    if (userInfo.user_id !== data.write_id) return false;
    const createAt = new Date(data.insert_date);
    const now = new Date();

    if (now.getTime() - createAt.getTime() < 1000 * 60 * 60) {
      return true;
    }
    return false;
  };

  return (
    <>
      {/* {commnetView()} */}
      {asDetail.isSuccess && asDetail.data.comments.length > 0 ? (
        asDetail.data.comments.map((el: any, idx: number) => {
          ////////////SOS
          return userInfo.user_id == "m1" && ugcList?.comment?.includes(el.comment_idx) ? (
            <CommentItemSet key={idx} ref={cmtListRef}>
              <div className="thumb">
                <Thumbnail width={40} height={40} br="20px" src={Thumb[`${el.writer_type}`]} />
              </div>
              <div className="comment-wrap">
                <div className="user-name">{el.writer_name}</div>
                <div className="content" style={{ color: "red" }}>
                  {"신고된 댓글입니다."}
                </div>
              </div>
            </CommentItemSet>
          ) : (
            <CommentItemSet key={idx} ref={cmtListRef}>
              <div className="thumb">
                <Thumbnail width={40} height={40} br="20px" src={Thumb[`${el.writer_type}`]} />
              </div>
              <div className="comment-wrap">
                <div className="user-name">
                  {el.writer_name}
                  {/* 2차 예정 */}
                  {/* <CommentBtn>
                      <button type="button">수정</button> | <button type="button">삭제</button>
                    </CommentBtn> */}
                  <CommentBtn>
                    {canDelete(el) && (
                      <button type="button" onClick={() => handleDelete(el.comment_idx)}>
                        삭제
                      </button>
                    )}
                  </CommentBtn>
                </div>
                <div className="content">{el.contents}</div>
                {el.images.length > 0 && (
                  <div className="img-wrap">
                    <ul>
                      {el.images
                        .filter((e: any, i: number) => i < 3)
                        .map((imgEl: any, imgIdx: number) => {
                          return (
                            <li key={imgIdx} data-cmt-type="parent" data-cmt-idx={idx} data-img-idx={imgIdx} onClick={props.onClick}>
                              {imgEl.ext === "mp4" || imgEl.ext === "mov" ? (
                                <VideoBox
                                  vimeoId={imgEl.img_url}
                                  //src={imageServerIp + imgEl.img_url}
                                />
                              ) : (
                                <img src={imageServerIp + imgEl.img_url} alt={imgEl.img_origin_name} />
                              )}
                            </li>
                          );
                        })}
                    </ul>
                    {el.images.length > 3 && (
                      <button type="button" className="view-more">
                        +<span>{el.images.length - 3}</span>
                      </button>
                    )}
                  </div>
                )}
                <div className="date">
                  {moment(`${el.insert_date}`).format("YYYY.MM.DD HH:mm")}
                  <CommentBtn>
                    <button type="button" onClick={() => reCommentBtn(el.writer_name, el.comment_idx)}>
                      답글 달기
                    </button>
                    {userInfo.user_id == "m1" && (
                      <button style={{ color: "red" }} type="button" onClick={(res) => sosContentSet(SOS_AS_COMMENT, el.comment_idx)}>
                        신고
                      </button>
                    )}
                  </CommentBtn>

                  {/* 자신의 댓글에 댓글 못달게
                    {userInfo.user_id !== el.write_id && (
                    )}
                    */}
                </div>
              </div>
              {el.childComments && (
                <ul className="child-cmt">
                  {el.childComments.map((cEl: any, cIdx: number) => {
                    return (
                      <CommentItemSet key={cIdx}>
                        <div className="thumb">
                          <Thumbnail width={40} height={40} br="20px" src={Thumb[`${cEl.writer_type}`]} />
                        </div>
                        <div className="comment-wrap">
                          <div className="user-name">
                            {cEl.writer_name}
                            {/* 2차 예정 */}
                            {/* <CommentBtn>
                                <button type="button">수정</button> | <button type="button">삭제</button>
                              </CommentBtn> */}
                            <CommentBtn>
                              {canDelete(cEl) && (
                                <button type="button" onClick={() => handleDelete(cEl.comment_idx)}>
                                  삭제
                                </button>
                              )}
                            </CommentBtn>
                          </div>
                          <div className="content">{cEl.contents}</div>
                          {cEl.images.length > 0 && (
                            <div className="img-wrap">
                              <ul>
                                {cEl.images
                                  .filter((ce: any, ci: number) => ci < 3)
                                  .map((cImgEl: any, cImgIdx: number) => {
                                    return (
                                      <li
                                        key={cImgIdx}
                                        data-cmt-type="child"
                                        data-cmt-idx={idx}
                                        data-cmtchild-idx={cIdx}
                                        data-img-idx={cImgIdx}
                                        onClick={props.onClick}
                                      >
                                        {cImgEl.ext === "mp4" || cImgEl.ext === "mov" ? (
                                          <VideoBox
                                            vimeoId={cImgEl.img_url}
                                            // src={imageServerIp + cImgEl.img_url}
                                          />
                                        ) : (
                                          <img src={imageServerIp + cImgEl.img_url} alt={cImgEl.img_origin_name} />
                                        )}
                                      </li>
                                    );
                                  })}
                              </ul>
                              {cEl.images.length > 3 && (
                                <button type="button" className="view-more">
                                  +<span>{cEl.images.length - 3}</span>
                                </button>
                              )}
                            </div>
                          )}
                          <p className="date">{moment(`${cEl.insert_date}`).format("YYYY.MM.DD HH:mm")}</p>
                        </div>
                      </CommentItemSet>
                    );
                  })}
                </ul>
              )}
            </CommentItemSet>
          );
        })
      ) : (
        <NoResult>작성된 댓글이 없습니다.</NoResult>
      )}
    </>
  );
};

const CommentItemSet = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  .thumb {
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    vertical-align: top;
  }
  .comment-wrap {
    display: inline-block;
    width: calc(100% - 40px);
    padding-left: 15px;
    .user-name {
      position: relative;
      padding-right: 80px;
      margin-bottom: 10px;
      font-weight: 700;
    }
    .content {
      line-height: 1.6;
    }
    .img-wrap {
      overflow: hidden;
      position: relative;
      display: inline-block;
      width: 100%;
      margin-top: 20px;
      > ul {
        overflow: hidden;
        display: flex;
        width: auto;
        height: 95px;
        > li {
          overflow: hidden;
          position: relative;
          width: 33.3%;
          height: 100%;
          border: 1px solid #707070;
          border-right: none;
          background: #7f7f7f 0% 0% no-repeat padding-box;
          -webkit-box-flex: 0;
          flex: 0 0 auto;
          &:last-child {
            border-right: 1px solid #707070;
          }
          img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: block;
            object-fit: cover;
            max-width: 100%;
            height: auto;
            box-sizing: border-box;
          }
        }
      }
      .view-more {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 28px;
        height: 28px;
        background-color: ${({ theme }) => theme.color.secondary};
        opacity: 0.7;
        color: #fff;
        border: none;
      }
    }
    .date {
      position: relative;
      padding-right: 50px;
      margin-top: 10px;
      color: #818181;
      font-family: "Poppins";
      font-weight: 400;
    }
  }
  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  > .child-cmt {
    padding-left: 30px;
    > li {
      position: relative;
      padding: 20px 0;
      &:first-child {
        margin-top: 10px;
        border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
      }
      &:last-child {
        padding-bottom: 0;
      }
    }
  }
`;

const CommentBtn = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  color: #818181;
  font-weight: 400;
  > button {
    padding: 0 10px;
    border: none;
    background: none;
    appearance: none;
    color: #818181;
  }
`;

const NoResult = styled.li`
  margin: 80px 0 40px;
  text-align: center;
`;

export default CommentItem;
